const storeSettings = {
  dispensarySettings: "Dispensary settings",
  saveSettings: "Save settings",
  dispensaryInfo: {
    title: "Dispensary info",
    description: "View and update your dispensary's details.",
    caption: "Details related to your dispensary that Fullscript has on file.",
    businessInformationSummary: "Business information summary",
    seeFullDefinition: "See full definition in our",
    accountType: "Account type",
    businessNo: "Business #",
    financialAddress: "Financial address",
    financialAddressCaption:
      "This address should match the address on file with your financial institution.",
    contactDetails: "Contact email",
    contactDetailsCaption: "The email address to your Dispensary.",
    businessInformationUpdated: "Business information updated",
    businessInformationUpdatedCaption: "Your new details have been successfully saved.",
  },
  certifications: {
    title: "Certifications",
    description: "Manage your professional certifications on file.",
  },
  credentials: {
    title: "Credentials",
    description: "Manage your professional credentials on file.",
  },
  integrations: {
    title: "Integrations",
    description: "Setup and manage integrations with an EHR.",
  },
  staffSettings: {
    title: "Staff settings",
    description: "Add and manage other practitioners that are part of your dispensary.",
  },
  payments: {
    title: "Payments",
    taxTitle: "Payouts and tax",
    businessFinancialsTitle: "Business financials",
    description: "Adjust your banking info and set your dispensary's margin.",
    descriptionWithDiscounts:
      "Adjust your banking info, dispensary margin, and {{ patientTerm }} discounts.",
    new: {
      businessFinancialsTitle: "Financials and discounts",
      descriptionWithDiscounts:
        "Update banking details, profit account settings, or {{patientTerm}} discounts.",
    },
  },
  permissions: {
    title: "Permissions and disclosures",
    description:
      "Customize what practitioners, staff, and {{patientTermPlural}} can see, including disclosure settings for email communications.",
    practitioner: {
      saveMessageTitle: "Practitioner permissions updated",
      saveMessageCaption: "Your changes to practitioner permissions have been successfully updated",
      featuresettings: {
        title: "Feature settings",
        globalPatientAccess: {
          modal: {
            title: "Are you sure you want to change global {{patientTerm}} access?",
            description:
              "Changing your stores global {{patientTerm}} access will affect all practitioners and staff in this store. Do you wish to continue?",
            saveChange: "Save change",
          },
          toast_on: "Global {{patientTerm}} access turned on",
          toast_off: "Global {{patientTerm}} access turned off",
          toggleTitle: "Global {{patientTerm}} access",
          toggledDescription:
            "All practitioners under this account will be able to create {{treatmentPlanTermPlural}} and see past {{treatmentPlanTermPlural}} for all {{patientTermPlural}}.",
          note: "Note:",
          notePolicy:
            "Please ensure that this setting complies with the HIPAA policy of your practice.",
        },
        surveyScheduling: {
          toast_on: "Adherence survey scheduling turned on",
          toast_off: "Adherence survey scheduling turned off",
          toggleTitle: "Adherence survey scheduling",
          toggledDescription:
            "All practitioners under this account will be able to enable adherence survey scheduling.",
        },
      },
      referralBonus: {
        title: "Referral bonus",
        description:
          "Your dispensary will earn an additional {{bonusMarginAmount}}% margin for all qualifying practitioner referrals if the toggle is turned on.",
        note: "<0>Note:</0>Please ensure this aligns with your practice's policies.",
        modalTitle: "Turn off your referral bonus?",
        modalText:
          "Your dispensary won't earn an additional {{bonusMarginAmount}}% margin for any current or future referrals.",
        modalPrimaryButton: "Cancel",
        modalSecondaryButton: "Yes, turn off",
        toastOn: "Referral bonus turned on",
        toastOff: "Referral bonus turned off",
      },
      reportAccess: {
        title: "Report access",
        newTitle: "Reports and analytics access",
        description:
          "Practitioners who are added to the list below will be able to access and download financial reports.",
        newDescription:
          "Practitioners and clerks given access below can view and download financial reports, and access analytics.",

        access: "Access",
        notePolicy: "As the dispensary owner you have access to all reports.",
        newNotePolicy:
          "Note: As the dispensary owner you have access to all reports and analytics.",
      },
    },
    patient: {
      saveMessageTitle: "{{patientTermCapitalized}} permissions updated",
      saveMessageCaption:
        "Your changes to {{patientTerm}} permissions have been successfully updated",
      catalogPermissions: "Catalog permissions",
      friendInvites: "Friend invites",
      friendInvitesDescription:
        "When enabled, all {{patientTermPlural}} will be able to invite up to 5 friends. Invited friends will have access to the same supplement catalog as the invitee and will appear as {{patientTermPlural}} in this account.",
      friendInvitesToastOn: "Friend invites turned on",
      friendInvitesToastOff: "Friend invites turned off",
      catalogPermissionsDescription:
        "Access is set at the dispensary level, applying to all {{patientTermPlural}} in your dispensary. Below are the catalog permissions available to customize and restrict access to the catalog.",
      mostCommon: "Most common",
      openCatalog: "Open catalog",
      privateFavorites: "Private categories and favorites",
      restrictedCatalog: "Restricted catalog",
      closedCatalog: "Closed catalog",
      openCatalogDescription:
        "{{patientTermCapitalized}} have access to self-serve & can purchase across Fullscript's entire product catalog.",
      newOpenCatalogDescription:
        "{{patientTermCapitalized}} have access to self-serve & can purchase across Fullscript's entire product catalog. Minor dependents will not have access to the open catalog.",
      privateFavouritesDescription:
        "{{patientTermCapitalized}} have access to any products from the Fullscript catalog, but do not see which products you have favorited or added to your categories.",
      restrictedCatalogDescription:
        "{{patientTermCapitalized}} can only access your custom catalog and any personalized {{treatmentPlanTermPlural}} you have written for them.",
      closedCatalogDescription:
        "{{patientTermCapitalized}} can only access specific products that you {{treatmentPlanTermPastParticiple}} for them or from a Favorites category you make visible to them.",
      restrictedBrands: "Restricted brands",
      restrictedBrandsInformation:
        "These brands are not available for {{patientTermPluralized}} to self-serve. {{patientTermCapitalized}} can request access for restricted products. To give them access, recommend the product to them through a plan.",
      emailDisclosures: "Email Disclosures",
      emailDisclosuresDescription:
        "Control what information is disclosed in {{patientTerm}} emails sent from your dispensary.",
      profitDisclosure: "Profit Disclosure",
      profitDisclosureDescription:
        "When enabled, emails will disclose that your dispensary may profit from {{patientTerm}} orders.",
      profitDisclosureToastOn: "Profit disclosure turned on",
      profitDisclosureToastOff: "Profit disclosure turned off",
      emailFooterPreviewLabel: "{{patientTermCapitalized}} email footer preview",
      emailFooterText:
        "{{storeName}} partners with Fullscript to provide high-quality supplements. While similar products are available elsewhere, Fullscript was chosen for its quality and convenience. {{storeName}} may benefit from purchases made from {{storeName}}.",
      defaultStoreName: "Your dispensary",
    },
  },
  tax: {
    title: "Tax",
    description: "Your dispensary's tax info on file.",
  },
  websiteButtons: {
    title: "Website buttons",
    description: "Embed links to Fullscript from a personal website.",
  },
  landingPage: {
    title: "{{patientTermCapitalized}} welcome page",
    description:
      "View and update your public-facing welcome page to create a clear first impression for {{patientTermPlural}}.",
  },
  landingSettingsPage: {
    title: "{{patientTermCapitalized}} welcome page",
    description:
      "View and update your public-facing welcome page to create a clear first impression for {{patientTermPlural}}.",
    preTip: "Tip: ",
    tip: "Your dispensary name appears on {{patientTermPlural}} emails, including treatment plan notifications. Update your dispensary name so your {{patientTermPlural}} create an immediate association with your practice.",
    copyStoreLink: "Copy store link",
    copyStoreLinkSuccess: "Store link copied successfully",
    dispensaryDetailsTitle: "Dispensary details",
    dispensaryNameLabel: "Dispensary name",
    dispensarySlugInputName: "Dispensary slug",
    dispensarySlugInstructions: "Enter store name",
    slugBase: "URL: {{- base }}/welcome/",
    slugNoteBold: "Note: ",
    slugNote:
      "This is the unique URL for your dispensary. Embed this in your personal website or send it in an email to {{patientTermPlural}} to give them access.",
    previewButton: "Preview welcome page",
    previewButtonMobile: "Preview",
    logo: "Logo",
    logoDropInstructions: "Upload your image here, ",
    browse: "browse",
    supportedFormats: "Supports: .PNG, .JPG, up to 2mb",
    sizeExplanationLine1: "Displays at: 240px x 140px on desktop",
    sizeExplanationLine2: "Displays at: 122px x 80px on mobile",
    removeLogo: "Remove logo",
    replaceLogo: "Replace logo",
    successToastTitle: "Landing page details updated",
    successToastDescription: "Changes to your dispensary landing page have been made successfully.",
    errorToastTitle: "Something went wrong",
    errorToastDescription:
      "We were not able to update your dispensary landing page details at this time.",
  },
  patientPromotions: {
    title: "{{patientTermCapitalized}} promotions",
    description:
      "Opt in to an upcoming sale to easily drive more {{patientTerm}} engagement, adherence, and orders.",
  },
  featureSettings: {
    title: "Feature settings",
    description: "Enable or disable features for your preferred experience.",
  },
  labSettings: {
    title: "Lab settings",
    description: "Manage your settings for labs access.",
    signingPrc: "Signing practitioner",
    signingPrcToggle: "Enable signing practitioner",
    content1:
      "Assign an authorized practitioner in your dispensary to sign for lab orders. Any time another practitioner in this dispensary recommends a test they're not authorized for, the signing practitioner's name will go on the requisition.",
    content2:
      "The signing practitioner will be notified each time a plan is sent that includes a lab order with their name on it. Both the signing practitioner and the recommending practitioner will be notified when test results are available to review.",
    learnMore: "Learn more",
    notSelected: "Not selected",
    labsAccess: "Labs access",
    practitionerName: "Practitioner name",
    Modality: "Modality",
    registeredForLabs: "Registered for labs",
    managePracs: "To manage practitioners in your dispensary, go to <1>Staff settings</1>.",
    registered: "Registered",
    notRegistered: "Not registered",
    notEligible: "Not eligible",
    emptyState: {
      content1:
        "There are no practitioners in your dispensary that are authorized to sign for lab orders.",
      content2:
        "Instead, you can use the authorization network of licensed practitioners to review and approve lab requisitions. The authorization network will cost your {{patientTerm}} {{labsAuthNetworkFee}} per panel or speciality test—charged as an additional fee when they're placing an order.",
    },
    labsRegistrationRequired: "Labs registration required",
    leavePage: {
      title: "Leave page with unsaved changes?",
      content: "Leaving this page will delete all unsaved changes.",
      stay: "Stay",
      leave: "Leave page",
    },
    changesSaved: "Changes saved",
    customFees: {
      title: "Custom fees",
      content:
        "Add a custom fee to each lab recommendation you send through Fullscript. The {{patientTerm}} is charged this fee in addition to the cost of the lab test.",
      content2:
        "You receive 95% of the custom fee and Fullscript retains 5%. Fullscript pays out your custom fee once lab test results are available.",
      content3:
        "This is the default custom fee for you and staff members, but you have the flexibility to edit or remove it for each individual lab recommendation.",
      toggle: "Enable custom fees",
      switchToProfit: "Switch to a profit account to use custom fees",
      switchCta: "Switch to profit account",
    },
    shareResults: {
      title: "Automatically share Quest Diagnostics results",
      shareResultsAutomatically: "Share results automatically",
      settingDescription1:
        "{{patientTermPlural}} will receive an email to view results and insights about each biomarker. You can choose to share results right away, or set a delay so you have time to review and edit them first.",
      settingDescription2:
        "This setting applies to all practitioners in this dispensary, for all Quest Diagnostic tests. If this setting is off, you can share results manually.",
      learnMore: "Learn more",
      chooseWhenToShareResults: "Choose when to share results",
      disclaimer: "Disclaimer for practitioners using the authorization network",
      disclaimerContent:
        "When results are shared with a {{patientTerm}}, they'll be advised to consult with their primary care provider if any results are outside the standard range.",
      disclaimerButton: "I acknowledge",
      disclaimerClose: "Close",
      dropdown: {
        asSoonAsAvailable: "As soon as available",
        delay1Day: "Delay 1 day",
        delay2Days: "Delay 2 days",
        delay3Days: "Delay 3 days",
        delay4Days: "Delay 4 days",
        delay5Days: "Delay 5 days",
        delay6Days: "Delay 6 days",
        delay7Days: "Delay 7 days",
      },
    },
    preferredPhlebotomists: {
      title: "Preferred phlebotomists for specialty kits",
      description1: "Your preferred phlebotomists are shown to patients for specialty kits. ",
      description2: "Quest tests aren't included, as they have their own draw locations.",
      addPhlebotomist: "Add phlebotomist",
      viewDetails: "View details",
      name: "Name",
    },
  },
} as const;

export { storeSettings };
